var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIco16MenuCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.552 12.45c.256-1.49 1.237-2.73 2.568-3.347M8.942 9.103c.488.228.93.538 1.307.914.65.65 1.1 1.49 1.262 2.432",
    transform: "translate(-340 -49) translate(340 49) translate(.5 .5) translate(.469 .469)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.063 7.031c0 3.884-3.148 7.032-7.032 7.032C3.148 14.063 0 10.915 0 7.03 0 3.148 3.148 0 7.031 0c3.884 0 7.032 3.148 7.032 7.031z",
    transform: "translate(-340 -49) translate(340 49) translate(.5 .5) translate(.469 .469)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.926 6.824c0 1.714-1.296 3.102-2.895 3.102S4.136 8.538 4.136 6.824c0-1.713 1.296-3.102 2.895-3.102 1.6 0 2.895 1.39 2.895 3.102z",
    transform: "translate(-340 -49) translate(340 49) translate(.5 .5) translate(.469 .469)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco16MenuCustomer);
export default __webpack_public_path__ + "static/media/ico16MenuCustomer.d2f92f4b.svg";
export { ForwardRef as ReactComponent };